import { Pill } from "@/components/shared/Pill";
import { Description as PageIcon } from "@mui/icons-material";
import { Box, Typography, useTheme } from "@mui/material";
import React from "react";

export interface FieldCellData {
    value: string | null;
    pageNum: number | null;
    scopeId: number;
}

interface FieldValueCellProps {
    data: FieldCellData | null;
}

export const FieldValueCell: React.FC<FieldValueCellProps> = React.memo(
    ({ data }) => {
        const theme = useTheme();

        if (!data || !data.value) {
            return (
                <Typography
                    variant="body2"
                    sx={{ color: theme.palette.text.secondary }}
                >
                    -
                </Typography>
            );
        }

        const handlePageClick = (e: React.MouseEvent) => {
            e.stopPropagation(); // Prevent row selection
            window.open(
                `/organizations/scopes/${data.scopeId}?page=${data.pageNum}`,
                "_blank"
            );
        };

        return (
            <Box
                sx={{
                    display: "flex",
                    alignItems: "start",
                    gap: 2,
                    py: 1,
                }}
            >
                <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
                    {data.value}
                </Typography>
                {data.pageNum && (
                    <Box sx={{ display: "flex" }}>
                        <Pill
                            icon={<PageIcon />}
                            label={`Page ${data.pageNum}`}
                            onClick={handlePageClick}
                            sx={{
                                backgroundColor: theme.palette.tertiary.main,
                                color: theme.palette.primary.main,
                                cursor: "pointer",
                                "&:hover": {
                                    backgroundColor: theme.palette.primary.main,
                                    color: theme.palette.primary.contrastText,
                                },
                            }}
                        />
                    </Box>
                )}
            </Box>
        );
    }
);
